import { createApiThunk } from 'utils/thunkWrapper'
import { getChallengeTypes as getChallengeTypesApi } from 'api/challenges-v2'
import type { GetChallengeTypesResponse } from 'api/types'

export const getChallengeTypes = createApiThunk<GetChallengeTypesResponse, void>({
  action: 'challengeTypes',
  request: () => getChallengeTypesApi(),
})
